/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

// PullColumnList
// -----------------------------------------------------------------------------
import { PullColumnList } from '../lists/PullColumns';
import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { ActiveColumnService } from 'src/app/services/legacy-helpers/ajs-upgrade-providers';
import { FancyFirebaseSplitDataListFactory } from '../../fancy-firebase/services/factories';
export * from '../lists/PullColumns';
import { LoggerServiceFactory } from '../../logging/LoggerServiceFactory';

@Injectable({
	providedIn: 'root',
})
export class PullColumnListFactory extends FancyFirebaseSplitDataListFactory {
	constructor(
		protected db: AngularFireDatabase,
		protected fancyActionTrackerFactory: FancyActionTrackerFactory,
		protected activeColumnService: ActiveColumnService
	) {
		super(db, fancyActionTrackerFactory);
		this.extraAngulars = { activeColumnService };
	}
	public create(path: RefOrObservable, fancyJoins?): PullColumnList {
		return super.create(PullColumnList, path, fancyJoins);
	}
}

// TimelineTicketList
// -----------------------------------------------------------------------------
import { TimelineTicketList } from '../lists/TimelineTicketList';
export * from '../lists/TimelineTicketList';

@Injectable({
	providedIn: 'root',
})
export class TimelineTicketListFactory extends FancyFirebaseSplitDataListFactory {
	constructor(
		protected db: AngularFireDatabase,
		protected fancyActionTrackerFactory: FancyActionTrackerFactory,
		protected activeColumnService: ActiveColumnService
	) {
		super(db, fancyActionTrackerFactory);
		this.extraAngulars = { activeColumnService };
	}
	public create(path: RefOrObservable, fancyJoins?, additionalDependencies?: any[]): TimelineTicketList {
		return super.create(TimelineTicketList, path, fancyJoins, additionalDependencies);
	}
}

// ConstraintList
// -----------------------------------------------------------------------------
import { ConstraintList } from '../lists/ConstraintList';
import { FancyActionTrackerFactory } from '../../fancy-firebase/services/fancy-action-tracker-factory.service';
export * from '../lists/ConstraintList';

@Injectable({
	providedIn: 'root',
})
export class ConstraintListFactory extends FancyFirebaseSplitDataListFactory {
	constructor(
		protected db: AngularFireDatabase,
		protected fancyActionTrackerFactory: FancyActionTrackerFactory,
		protected activeColumnService: ActiveColumnService
	) {
		super(db, fancyActionTrackerFactory);
		this.extraAngulars = { activeColumnService };
	}
	public create(path: RefOrObservable, fancyJoins?, additionalDependencies?: any[]): ConstraintList {
		return super.create(ConstraintList, path, fancyJoins, additionalDependencies);
	}
}

// SwimlaneList
// -----------------------------------------------------------------------------
import { SwimlaneList } from '../lists/SwimlaneList';
import { RefOrObservable } from '../../fancy-firebase/base/interfaces';
export * from '../lists/SwimlaneList';

@Injectable({
	providedIn: 'root',
})
export class SwimlaneListFactory extends FancyFirebaseSplitDataListFactory {
	constructor(
		protected db: AngularFireDatabase,
		protected fancyActionTrackerFactory: FancyActionTrackerFactory
	) {
		super(db, fancyActionTrackerFactory);
	}
	public create(path: RefOrObservable, fancyJoins?): SwimlaneList {
		return super.create(SwimlaneList, path, fancyJoins);
	}
}
